import { Option } from 'lib/api/leadOpportunities/types';
import { defaultLeadTypeOption } from 'lib/const/leads';

export const mapOptionsToValues = <T extends Record<string, Option[]>>(
  filters: Partial<T>
): Partial<{ [K in keyof T]: string[] }> =>
  Object.fromEntries(
    Object.entries(filters)
      .map(([k, arr]) => [k, (arr ?? []).map((o: Option) => o.value)])
      .filter(([, arr]) => (arr as string[]).length > 0)
  ) as Partial<{ [K in keyof T]: string[] }>;

const LEAD_REPORTS_FILTERS = 'LEAD_REPORTS_FILTERS';

export const getDropdownSelectionsByUserId = (
  userId: string
): Record<string, { value: string; label: string }[]> => {
  try {
    const stored = localStorage.getItem(LEAD_REPORTS_FILTERS);
    if (!stored) return defaultLeadTypeOption;

    const parsed = JSON.parse(stored);
    return parsed[userId] || defaultLeadTypeOption;
  } catch (error) {
    console.error(
      'Failed to parse dropdownSelections from localStorage:',
      error
    );
    return {};
  }
};

export const saveDropdownSelectionsByUserId = (
  userId: string,
  selections: Record<string, { value: string; label: string }[]>
) => {
  try {
    const existing = JSON.parse(
      localStorage.getItem(LEAD_REPORTS_FILTERS) || '{}'
    );
    const updatedWithUser = {
      ...existing,
      [userId]: selections,
    };
    localStorage.setItem(LEAD_REPORTS_FILTERS, JSON.stringify(updatedWithUser));
  } catch (error) {
    console.error('Failed to save dropdown selections:', error);
  }
};
